<ng-container *ngIf="appointmentId && noteForm">
	<form [formGroup]="noteForm">
		<ion-list mode="md">
			<ion-item>
				<ion-label>Subject: Cleared Note</ion-label>
			</ion-item>
			<ion-item>
				<ion-label position="stacked">Note:</ion-label>
				<ion-textarea
					formControlName="note"
					name="note"
					type="text"
					rows="8"
					autofocus="true"
					(ionBlur)="onBlurSaveNote()"
				></ion-textarea>
			</ion-item>
		</ion-list>
	</form>
</ng-container>
